module.exports = __webpack_public_path__ + "static/media/bg5.edaf9be1.jpg";